import { NgModule } from '@angular/core';
import { StateSlice } from '../state-slice';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { reducer } from './settings-reducer';
import { initialSettingsState } from './settings-state';
import { EffectsModule } from '@ngrx/effects';
import { SettingsEffects } from './settings-effects';
import { combineReducers, entityMetaReducer } from '@core/utils/state';

@NgModule({
    imports: [
        StoreModule.forFeature(StateSlice.SETTINGS, (reducer as ActionReducer<any, any>), {
            initialState: initialSettingsState,
            metaReducers: [entityMetaReducer],
            reducerFactory: combineReducers
        }),
        EffectsModule.forFeature([ SettingsEffects ])
    ],
    declarations: []
})
export class SettingsStateModule {}
